import { ChangeDetectorRef, Component, Input, Inject } from "@angular/core";
import * as GoldenLayout from "golden-layout";
import * as _ from "underscore";

import { UserService } from "@app/services/user.service";
import { User } from "@app/data/user";
import { GoldenLayoutService } from "@app/services/golden-layout.service";
import { GoldenLayoutBaseComponent } from "@app/components/editor/workspace/golden-layout-base.component";
import { TEXT_COMPONENT_KEY } from "@app/components/editor/workspace/golden-layout-definitions";
import { SimpleChanges } from "@angular/core";
import { PipeTransform } from "@angular/core";
import { Pipe } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { COUNTRIES, STATES_PROVINCES } from "@data/locale";
import * as tearSheetUtils from "@js/tear-sheet.utils";
import {
  GoldenLayoutComponentState,
  GoldenLayoutContainer,
} from "golden-layout/golden-layout.directive";

@Pipe({
  name: "replaceBusinessTags",
})
export class ReplaceBusinessTagsPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(html: string, user: User, preview: boolean): any {
    if (preview) {
      return this.sanitizer.bypassSecurityTrustHtml(
        tearSheetUtils.replaceUserInformation(html, user, 1)
      );
    }
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}

@Component({
  templateUrl: "./golden-layout-text.component.html",
})
export class GoldenLayoutTextComponent extends GoldenLayoutBaseComponent {
  user: User;

  constructor(
    @Inject(GoldenLayoutComponentState) state: any,
    @Inject(GoldenLayoutContainer) container: GoldenLayout.Container,
    goldenLayoutService: GoldenLayoutService,
    cdRef: ChangeDetectorRef,
    private userService: UserService
  ) {
    super(state, container, goldenLayoutService, cdRef);
    this.userService.me().then((user) => {
      this.user = user;
    });
  }
  onClick() {
    this.select(TEXT_COMPONENT_KEY);
  }
}
